<template>
  <!--  start navbar -->
  <div class="mainNavbar">

    <div class="desktopNavbar">
      <!--    logo section -->
      <div @click="$router.push('/')" class="logo">
        <img src="../../assets/navbar/logo.png" alt="">
        <span>دریک</span>
      </div>

      <!--    menu section-->
      <div class="menu">
        <ul>
          <li @click="$router.push(item.src)" v-for="(item , index) in menuData" :key="index">
            <span style="display: ruby">{{ item.name }}</span>
          </li>

          <li class="tooltip">
            <div class="other" @click="showTooltip = !showTooltip">
              سایر
              <img src="../../assets/navbar/arrow.png" alt="">
            </div>
            <transition name="slide">
              <the-tooltip-navbar v-if="showTooltip"  @close="showTooltip = false"/>
            </transition>
          </li>

        </ul>
      </div>

      <!--    account section -->
      <div class="account">
        <the-account/>
        <img @click="showMobileMenu = true"  src="../../assets/navbar/Hamburger.png" alt="">
      </div>
    </div>

    <!--    mobile menu -->
    <div class="mobileMenu" :style="{'width':(showMobileMenu)?'250px':'0px'}">
     <the-mobile-menu  @close="showMobileMenu = false"/>
    </div>

  </div>

</template>

<script>
import TheTooltipNavbar from "./the-tooltip-navbar";
import TheAccount from "./the-account";
import TheMobileMenu from "./the-mobile-menu";

export default {
  name: "the-Navbar",
  components: {TheMobileMenu, TheAccount, TheTooltipNavbar},
  data() {
    return {
      showMobileMenu:false,
      showTooltip: false,
      showaccount:false,
      menuData: [
        {name: 'خانه', src: '/'},
        {name: 'بازار ارز دیجیتال', src: '/trade'},
        {name: 'بازار طلا و سکه', src: '/goldTrade'},
        {name: 'معامله سریع (OTC)', src: '/otc'},
        {name: 'کارمزد سطوح کاربری', src: '/wages'},
      ],
    }
  },

  created() {
    //close header div function
    window.addEventListener("click", (event) => {
      if (!event.target.closest('.other')) {
        this.showTooltip = false
      }
      if (!event.target.closest('.account')) {
        this.showMobileMenu = false
      }
    })
  },
}
</script>

<style lang="scss" scoped>
.mobileMenu{
  transition: width 1s;
  overflow-x: hidden;
  position: fixed;
  z-index: 10;
  display: none;
  left: 0;
}
//general class
.public-row {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  font-size: clamp(14px, 2vw, 16px);
  color: #D7C8C8;
}

//main navbar style
.mainNavbar {
  position: fixed;
  top:0;
  right: 0;
  left: 0;
  z-index: 100;

  @extend .public-row;
  color: #D7C8C8;
  background: radial-gradient(50% 50% at 50% 50%, #0B1426 30.56%, #13171E 100%);
  height: 60px;
  padding: 0 24px;
  direction: rtl;


  .desktopNavbar{
    @extend .public-row;
    width: 100%;
    //  logo section
    .logo {
      @extend .public-row;
      color: #FBFBFD;
      flex-grow: 1;
      flex-basis: 100px;
      gap: 12px;
      align-items: center;
      height: 60px;
      cursor: pointer;

      img {
        width: 40px;
        height: 22px;
      }
    }

    //  menu section
    .menu {

      @extend .public-row;
      flex-grow: 4;
      flex-basis: 100px;

      ul {
        display: flex;
        flex-direction: row;
        gap: 49px;

        li {
          text-decoration: none;
          list-style: none;
          cursor: pointer;
          width: auto;

          span{
            white-space: nowrap;
          }

          &:hover {
            color: #FBFBFD;
          }

          img {
            width: 8px;
            height: 8px;
          }
        }

        .tooltip {
          width: 130px;

          .other {
            position: absolute;
          }
        }
      }
    }

    //  account section
    .account {
      @extend .public-row;
      flex-grow: 1;
      flex-basis: 100px;
      height: 60px;
      align-items: center;
      justify-content: end;
      gap: 20px;

      img {
        width: clamp(30px, 2vw, 45px);
        cursor: pointer;
      }
    }
  }



}

//media query
@media screen and (min-width: 1200px) {
  .account img {
    display: none !important;
  }
}

@media screen and (max-width: 1200px) and (min-width: 1101px) {
  .account img {
    display: none !important;
  }
}


@media screen and (max-width: 1100px) and (min-width: 980px) {
  .logo {
    flex-grow: 0 !important;
  }

  .menu ul {
    gap: 10px !important;
  }

  .account {
    flex-grow: 2;
  }

  .account img {
    display: none !important;
  }
}

;

@media screen and (max-width: 992px) {
  .menu {
    display: none !important;
  }
  .mobileMenu{
    display: block;
  }
}


</style>